import { useCallback } from 'react'
import { ScrollTrigger } from '../utils/gsap'
import {
  BOARD_DIMENSIONS_PIN_VH,
  BOARD_DIMENSIONS_SCRUB,
  computeDesktopCardMotion,
  getDimensionsCardTravelY,
  getDimensionsPinStart,
  getPinScrollDistance,
} from '../utils/scrollAnimation'
import { useGsapScroll } from './useGsapScroll'

const CARD_COUNT = 7

export function useDimensionsScroll(sectionRef, cardRefs, enabled) {
  const setup = useCallback(() => {
    const section = sectionRef.current
    if (!section) return

    const pinTarget = section.querySelector('[data-dimensions-pin]')
    if (!pinTarget) return

    const applyFrame = (progress) => {
      const travelY = getDimensionsCardTravelY(pinTarget.offsetHeight)

      cardRefs.current.forEach((card, index) => {
        if (!card) return

        const motion = computeDesktopCardMotion(index, CARD_COUNT, progress, travelY)

        card.style.opacity = String(motion.opacity)
        card.style.transform = `translate3d(0, calc(-50% + ${motion.translateY}px), 0)`
        card.style.pointerEvents = motion.pointerEvents
        card.style.visibility = motion.opacity > 0.01 ? 'visible' : 'hidden'
      })
    }

    ScrollTrigger.create({
      trigger: section,
      start: getDimensionsPinStart(),
      end: () => `+=${getPinScrollDistance(BOARD_DIMENSIONS_PIN_VH)}`,
      pin: pinTarget,
      pinSpacing: true,
      scrub: BOARD_DIMENSIONS_SCRUB,
      invalidateOnRefresh: true,
      anticipatePin: 1,
      fastScrollEnd: true,
      preventOverlaps: true,
      onUpdate: (self) => {
        applyFrame(self.progress)
      },
      onRefresh: (self) => {
        applyFrame(self.progress)
      },
    })

    applyFrame(0)
  }, [sectionRef, cardRefs])

  useGsapScroll(sectionRef, enabled, setup)
}
